// extracted by mini-css-extract-plugin
export default {"header":"header__o64N6","main-text":"main-text__ZAQt8","disable-right-addon-offset":"disable-right-addon-offset___PvbN","custom-styles":"custom-styles__sq2nf"};